import { LocaleType } from '../contentful/templates/types';
import {
  isDateRange,
  isSameDayDateRange,
  isSameMonthDateRange,
  isSameYearDateRange,
} from '../utils/date-utils';

type FormattedDateProps = {
  date?: Date | { start: Date; end: Date };
  locale?: LocaleType;
  timeZone?: string;
  options?: Intl.DateTimeFormatOptions;
};

const useFormattedDate = ({
  date,
  options,
  locale = 'fi',
  timeZone
}: FormattedDateProps): string => {

   const formatOptions: Intl.DateTimeFormatOptions = timeZone 
    ? { timeZone, ...options }
    : { ...options };

  const formatter = new Intl.DateTimeFormat(locale, formatOptions);
  if (!date) {
    return '';
  }
  if (isDateRange(date)) {
    const startParts = formatter.formatToParts(date.start);
    const endParts = formatter.formatToParts(date.end);

    if (!isSameDayDateRange(date)) {
      if (isSameMonthDateRange(date)) {
        const [startDay, separator] = startParts;
        const [endDay, ...restEnd] = endParts;
        return [
          `${startDay.value}${separator.value}-${endDay.value}`,
          ...restEnd.map(({ value }) => value),
        ].join('');
      }
      if (isSameYearDateRange(date)) {
        return [
          ...startParts.slice(0, -1).map(({ value }) => value),
          '-',
          ...endParts.map(({ value }) => value),
        ].join('');
      }
    } else {
      return formatter.format(date.start);
    }

    return `${formatter.format(date.start)} - ${formatter.format(date.end)}`;
  }

  return formatter.format(date);
};

export default useFormattedDate;
